import { features } from '@/mocks/superbuy';

export default function FeatureGrid() {
  return (
    <section className="py-24 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block text-xs tracking-[0.25em] uppercase text-secondary-600 font-medium mb-4 border border-secondary-300/50 px-3 py-1 rounded-full">
            Why Use Us
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-3">
            Everything Organized.
            <br />
            Nothing Missed.
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Superbuy Spreadsheet transforms chaotic product hunting into a streamlined discovery experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group bg-background-50 rounded-2xl p-6 md:p-7 hover:bg-primary-500 transition-all duration-300 cursor-default"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 rounded-xl bg-secondary-100 flex items-center justify-center mb-5 group-hover:bg-white/90 transition-all duration-300">
                <i className={`${feat.icon} text-secondary-600 text-lg md:text-xl group-hover:text-primary-700 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 group-hover:text-background-50 dark:group-hover:text-foreground-950 transition-colors duration-300 mb-2">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed group-hover:text-background-50/90 dark:group-hover:text-foreground-900 transition-colors duration-300">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}